import api from "@/router/api";

export default {
  async getAtividades(page, size, retornarNumPag, filtros) {
    const params = {
      page,
      size,
      sort: "dataCadastro,desc",
    };

    if (filtros) {
      if (filtros.status) params.status = filtros.status;
      if (filtros.modalidade) params.modalidade = filtros.modalidade;
      if (filtros.tipo) params.tipo = filtros.tipo;
      if (filtros.categoria) params.categoria = filtros.categoria;
    }

    const response = await api.get("/atividade", {
      params,
      public: true,
    });

    if (retornarNumPag) {
      return {
        atividades: response.data?.content ?? response.data ?? [],
        numPaginas: response.data?.totalPages ?? 1,
      };
    }
    return response.data?.content ?? response.data ?? [];
  },

  async getAtividadesAcao(page, size, acaoId, retornarNumPag, filtros) {
  const params = {
    page,
    size,
    sort: "dataCadastro,desc",
  };

  if (filtros) {
    if (filtros.status) params.status = filtros.status;
    if (filtros.modalidade) params.modalidade = filtros.modalidade;
    if (filtros.tipo) params.tipo = filtros.tipo;
    if (filtros.categoria) params.categoria = filtros.categoria;
  }

  const response = await api.get(`/atividade/acao/${acaoId}`, {
    params,
  });

  if (retornarNumPag) {
    return {
      atividades: response.data?.content ?? [],
      numPaginas: response.data?.totalPages ?? 1,
      totalElementos: response.data?.totalElements ?? 0,
    };
  }

  return response.data?.content ?? response.data ?? [];
},

  async getAtividadesComFiltros(page, size, filtros, acaoId) {
    const url = acaoId ? `/atividade/filtros/${acaoId}` : "/atividade/filtros";
    const response = await api.post(url, filtros, {
      params: {
        page,
        size,
        sort: "dataCadastro,desc",
      },
    });
    return response.data;
  },

  async getAtividadesPorPalavraChave(palavra, page, size) {
    const response = await api.get("/atividade/busca", {
      params: {
        palavra,
        page,
        size,
        sort: "dataCadastro,desc",
      },
    });
    return response.data;
  },

  async getAtividadesUnidade(page, size, unidadeId) {
    const response = await api.get(`/atividade/unidade/${unidadeId}`, {
      params: {
        page,
        size,
        sort: "dataCadastro,desc",
      },
      public: true,
    });

    if (response.data && Array.isArray(response.data.content)) {
      return {
        content: response.data.content,
        totalPages: response.data.totalPages || 1,
      };
    }
    return {
      content: Array.isArray(response.data) ? response.data : [],
      totalPages: 1,
    };
  },

  async getAtividadeId(id) {
    const response = await api.get(`/atividade/${id}`, { public: true });
    return response.data;
  },

  async postAtividade(dadosAtividade) {
    const response = await api.post("/atividade", dadosAtividade);
    return response.data;
  },

  async putAtividade(atividadeId, dadosAtividade) {
    const response = await api.put(`/atividade/${atividadeId}`, dadosAtividade);
    return response.data;
  },

  async getTiposeSubtipos() {
    const response = await api.get("/tipo/ordenado");
    return response.data;
  },

  async getSubTipoPorId(id) {
    const response = await api.get(`/tipo/subtipo/${id}`, {
      params: { id },
    });
    return response.data;
  },

  async deletAtividade(atividadeId) {
    const response = await api.delete(`/atividade/${atividadeId}`);
    return response.data;
  },

  async cancelarAtividade(atividadeId, motivo) {
    const response = await api.get("/atividade/cancelar", {
      params: {
        atividadeId,
        motivo,
      },
    });
    return response.data;
  },

  async encerrarAtividade(atividadeId) {
    const response = await api.get("/atividade/encerrar", {
      params: { atividadeId },
    });
    return response.data;
  },

  async concluirAtividade(atividadeId) {
    const response = await api.put(`/atividade/${atividadeId}/concluir`);
    return response.data;
  },

  async getParticipantesAtividade(atividadeId) {
    const response = await api.get(`/atividade/${atividadeId}`, {
      params: {
        page: 0,
        size: 50,
      },
      public: true,
    });
    return response.data.content;
  },

  async escolherParticipantesAtividade(atividadeId, dadosParticipantes) {
    const response = await api.post(
      `/atividade/${atividadeId}/escolher/participantes`,
      dadosParticipantes
    );
    return response.data;
  },

  async cadastrarGrupoAtividade(atividadeId, membrosGrupo) {
    const response = await api.post(
      `/atividade/criarGrupo/${atividadeId}`,
      membrosGrupo
    );
    return response.data;
  },

  async adicionarMembroGrupo(atividadeId, membrosGrupo) {
    const response = await api.post(
      `/atividade/grupo/adicionar-membro/${atividadeId}`,
      membrosGrupo
    );
    return response.data;
  },

  async removerMembroGrupo(atividadeId, membrosGrupo) {
    const response = await api.put(
      `/atividade/grupo/remover-membros/${atividadeId}`,
      membrosGrupo
    );
    return response.data;
  },

  async getGrupoAtividade(atividadeId) {
    const response = await api.get(`/atividade/grupo/${atividadeId}`);
    return response.data;
  },

  async promoverMembroEquipe(atividadeId, dadosMembroTime) {
    const response = await api.put(
      `/atividade/${atividadeId}/promover/${dadosMembroTime.id}`
    );
    return response.data;
  },

  async rebaixarMembroEquipe(atividadeId, dadosMembroTime) {
    const response = await api.put(
      `/atividade/${atividadeId}/rebaixar/${dadosMembroTime.id}`
    );
    return response.data;
  },
};
